import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import App from './App.jsx'

import { LanguageProvider } from './context/LanguageContext'
import { ConfigProvider } from './context/ConfigContext'
import { AuthProvider } from './context/AuthContext'

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <LanguageProvider>
            <AuthProvider>
                <ConfigProvider>
                    <App />
                </ConfigProvider>
            </AuthProvider>
        </LanguageProvider>
    </StrictMode>,
)
